<div class="modal-body text-center">
  <button type="button" data-bs-dismiss="modal" aria-label="Popup close" class="btn-close" (click)="onClose();"></button>
  <div>
    <div class="vault-auth-code forecast-report d-flex justify-content-center">
      @for (item of futureWeatherInfo; track item) {
        <div class="single-forecast-report">
          <div class="weather-date">{{item?.date | date:'EEE'}}</div>
          <div class="weather-temp flex-column">
            <img src="{{item?.day?.condition?.icon ?? '/assets/images/weather-icon.svg'}}" alt="weather icon">
            <div class="weather-text">{{item?.day?.maxtemp_f}}°</div>
          </div>
          <div class="weather-location">
            @if (item?.day?.location) {
              <div>
                <span class="weather-text">{{item?.day?.location?.name}},
                  {{item?.day?.location?.region ||
                item?.day?.location?.country}}</span>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>